// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.PNG';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-company">
          <h3>TechStride Consulting</h3>
          <p>Your trusted partner for digital transformation.</p>
        </div>
        <div className="footer-links">
          <div className="footer-links-column">
            <h4>Services</h4>
            <Link to="/services">Services</Link>
            <Link to="/activities">Activities</Link>
          </div>
          <div className="footer-links-column">
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/team">Our team</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
        <div className="footer-newsletter">
          <h4>Stay informed</h4>
          <p>Sign up for our newsletter to receive our latest updates.</p>
          <form className="newsletter-form">
            <input type="email" placeholder="Your email" />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 TechStride Consulting. All rights reserved.</p>
        <div className="footer-social">
          <a href="https://www.linkedin.com/company/tech-stride-consulting/?viewAsMember=true" className="social-icon">LinkedIn</a>
          <a href="https://www.facebook.com/techstrideconsulting" className="social-icon">Facebook</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;